<template>

  <div class="sections">
    <transition appear>
      <introduction></introduction>
    </transition>
    <transition appear>
      <explanation></explanation>
    </transition>
    <transition appear>
      <call-to-action></call-to-action>
    </transition>
    <transition appear>
      <explanation-organs></explanation-organs>
    </transition>
    <transition appear>
      <gallery></gallery>
    </transition>
  </div>

</template>

<script>
import Introduction from './Introduction'
import Explanation from './Explanation'
import ExplanationOrgans from './ExplanationOrgans'
import CallToAction from './CallToAction'
import Gallery from '../Global/Gallery'

export default {
  name: 'HomePage',
  components: {
    Introduction,
    Explanation,
    ExplanationOrgans,
    CallToAction,
    Gallery
  }
}
</script>



// WEBPACK FOOTER //
// src/components/HomePage/HomePage.vue